// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Material UI
import { Dialog, DialogContent } from "@material-ui/core";
// SVG
import {infoSvg} from "assets";

class Info extends Component {

    render() {
        const { t, from, type } = this.props;
        return (
            <Dialog onClose={this.props.onClose} className="dialog_info" open={true}>
                <DialogContent>
                    <div>
                        <h4>{t(`frontend_info.${from}.${type}_title`)}</h4>
                        {infoSvg()}
                        <p className="p2">{t(`frontend_info.${from}.${type}_description`)}</p>
                        <button className="btn btn-info" onClick={(e) => this.props.onClose(e)}>{t("inputs:button.accept")}</button>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const success = connect(
    mapStateToProps
)(Info);

export default withTranslation("notifications")(withRouter(success));
